import { useState, useEffect } from 'react'
import { apiClient } from '../services/api'
import { useAuthStore } from '../store/authStore'

export interface UserProfile {
  displayName: string
  email: string
  phone: string
  apartmentNumber: string
  parkingSpaceNumber?: string
  status: string
  createdAt: string
  activatedAt?: string
}

export function useProfile() {
  const { user } = useAuthStore()
  const [profile, setProfile] = useState<UserProfile | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) { setProfile(null); setLoading(false); return }
    apiClient.get<UserProfile>('/api/user/profile')
      .then(setProfile)
      .catch(() => setProfile(null))
      .finally(() => setLoading(false))
  }, [user])

  return { profile, loading }
}
